module.exports = __webpack_public_path__ + "img/portfolio-08-02-670x479.ae942d27.jpg";